<template>
  <UikitDialog
    :model-value="modelValue"
    position="right"
    content-class="osk-offer-price-dialog"
    @update:model-value="closeDialog"
  >
    <div class="osk-offer-price-dialog__img-container">
      <img
        v-if="isInternational"
        class="osk-offer-price-dialog__img"
        src="~assets/img/home/download-app.png"
        alt="women"
      >
      <img
        v-else
        class="osk-offer-price-dialog__img"
        src="~assets/img/home/download-app-int.png"
        alt="women"
      >
    </div>

    <div class="osk-mt-mmd osk-px-md">
      <i18n-t
        keypath="product.action.offerPriceMobileDialog.header"
        class="text-heading osk-mt-mmd"
        tag="div"
      >
        <template #promo>
          <span class="text-grey">
            {{ $t('product.action.offerPriceMobileDialog.header.promo', { promoCode, sale }) }}
          </span>
        </template>
      </i18n-t>

      <div class="osk-mt-lg">
        {{ $t('product.action.offerPriceMobileDialog.text') }}
      </div>

      <div class="osk-mt-mlg">
        <UikitButton
          full-width
          href="https://oskelly.onelink.me/kabM/njg7mgte"
          target="_blank"
        >
          {{ $t('product.action.offerPriceMobileDialog.downloadBtn') }}
        </UikitButton>
      </div>
    </div>
  </UikitDialog>
</template>

<script lang="ts" setup>
defineProps<{
  modelValue: boolean,
}>();

const emit = defineEmits<{
  (e: 'stay'): void,
  (e: 'update:modelValue', value: boolean): void,
}>();

const { isInternational } = useInternational();
const { sale, promoCode } = useWebToApp();

function closeDialog() {
  emit('update:modelValue', false);
}
</script>

<style lang="scss">
@import "~/assets/scss/settings/index";

.osk-offer-price-dialog {
  .osk-dialog__close {
    display: none;
  }

  &.osk-dialog__body {
    padding: 0 0 16px;
  }

  &__img-container {
    background: url('~/assets/img/home/download-app-bg.webp') no-repeat;
  }

  &__img {
    height: 266px;
    object-fit: cover;
    object-position: 70% 50%;
  }
}
</style>
